import React from 'react';
import { DownloadIcon } from '../../../assets/svg/SVGComponents';
import { Card, DownloadButton, FileBadge, Info, PendingButton } from './styles';

interface IRulesDownloadCardProps {
  /** Link do PDF. Vazio ou ausente mostra o estado "Disponível em breve". */
  href?: string | null;
  title?: string;
  description?: string;
}

/** Card de download do regulamento do torneio (PDF). */
const RulesDownloadCard: React.FC<IRulesDownloadCardProps> = ({
  href,
  title = 'Regulamento do torneio',
  description = 'Regras completas das modalidades e categorias, critérios de pontuação e desempate.',
}) => (
  <Card>
    <FileBadge aria-hidden>PDF</FileBadge>
    <Info>
      <h3>{title}</h3>
      <p>{description}</p>
    </Info>
    {href ? (
      <DownloadButton
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <DownloadIcon
          aria-hidden
          stroke="currentColor"
          strokeWidth={1.75}
          fill="none"
        />
        Baixar regulamento
      </DownloadButton>
    ) : (
      <PendingButton type="button" disabled>
        Disponível em breve
      </PendingButton>
    )}
  </Card>
);

export default RulesDownloadCard;
